import { createContext, useContext } from 'react';

const AccordionContext = createContext({
    disabled: false,
    expanded: false,
    id: '',
    size: 'M',
    variant: 'primary',
});
const useAccordion = () => useContext(AccordionContext);

export { AccordionContext, useAccordion };
